import { gql } from '@apollo/client'

export const EXPORT_PROCESSINGS_QUERY = gql`
  query exportProcessings(
    $format: ExportTypeEnum
    $filter: ProcessingFilter
    $sortBy: ProcessingSort
    $ids: [ID!]
    $columns: [ExportColumn!]
  ) {
    exportProcessings(
      format: $format
      filter: $filter
      sortBy: $sortBy
      ids: $ids
      columns: $columns
    )
  }
`
